import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const CustomConfirmAbortDialog: React.FC<{
  open: boolean;
  title: string;
  text: string | React.ReactNode;
  confirmButton: string;
  abortButton: string;
  onAbort: () => void;
  onConfirm: () => void;
}> = ({ open, title, text, confirmButton, abortButton, onAbort, onConfirm }) => {
  return (
    <React.Fragment>
      <Dialog open={open} onClose={onAbort} maxWidth="sm" fullWidth>
        <DialogContent>
          <Stack spacing={2}>
            <Typography variant="h2">{title}</Typography>
            {typeof text === 'string' ? <Typography>{text}</Typography> : text}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onAbort}>{abortButton}</Button>
          <Button variant="contained" onClick={onConfirm}>
            {confirmButton}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default CustomConfirmAbortDialog;
